<!-- 审核查看 -->

<template>
  <div class="province-C">
    <div class="headBar">
      <span v-if="querys.pressType == 1">音像制品出版单位审核</span>
      <span v-else-if="querys.pressType == 2">电子出版物出版单位审核 </span>
      <i class="el-icon-arrow-right"></i>
      <span>{{ querys.pressName }}</span>
      <!-- <el-button type="primary" size="mini" class="recordBtn" @click="dialogTableVisible = true">流转记录</el-button> -->
    </div>
    <CommonTab
      ref="mainTab"
      :cancelFlag="false"
      v-if="wSat == 1"
      :pressType="querys.pressType"
      :pressDat="resDat"
      role="show"
      :organization="querys.pressName"
      :defaultYear="querys.year1" />

    <div class="headBar">
      <span>出版单位信息统计</span>
    </div>
    <div class="progressTab" style="margin-left: 30px; font-size: 14px" v-if="querys.pressType == 1">
      <span style="font-weight: bold; color: red">以下情况数字会进行标红</span><br />
      <span> 1、领导班子成员持证上岗率：</span><span>上岗率低于50%</span>

      <br />
      <span> 2、出版物数量：</span>
      2023 + 2024年出版物数量小于10

      <br />
      <span> 3、编辑人员人数：</span>
      取得国家出版专业技术人员资格的编辑人员，其人数小于10人

      <br />
      <span> 4、出版专业中级职称以上人数：</span>
      具有中级以上出版专业职业资格人数小于5人

      <!-- <br />
      <span> 5、出版许可证：</span>
      有效期在2025年6月30号之前 -->
    </div>
    <!--zym.电子-->
    <div class="progressTab" style="margin-left: 30px; font-size: 14px" v-if="querys.pressType == 2">
      <span style="font-weight: bold; color: red">以下情况数字会进行标红</span><br />
      <span> 1、领导班子成员持证上岗率：</span><span>上岗率低于50%</span>

      <br />
      <span> 2、出版专业中级职称以上人数：</span>
      具有中级以上出版专业职业资格人数小于2人

      <!-- <br />
      <span> 3、出版许可证：</span>
      有效期在2025年6月30号之前 -->
    </div>
    <div class="informationStatic" style="padding: 10px 50px 50px 50px">
      <div class="left">
        <div class="multiple">
          <p>第一年度出版物数量</p>
          <span
            :class="
              querys.pressType == 1 && publishUnitJson.firstYearDeliverNum + publishUnitJson.secondYearDeliverNum < 10
                ? 'highlight'
                : ''
            "
            >{{ publishUnitJson.firstYearDeliverNum }}</span
          >
        </div>
        <div class="multiple">
          <p>第二年度出版物数量</p>
          <span
            :class="
              querys.pressType == 1 && publishUnitJson.firstYearDeliverNum + publishUnitJson.secondYearDeliverNum < 10
                ? 'highlight'
                : ''
            "
            >{{ publishUnitJson.secondYearDeliverNum }}</span
          >
        </div>
        <!-- <div class="multiple">
          <p>出版许可证</p>
          <span
            :class="
              publishUnitJson.pqualificationvalid && publishUnitJson.pqualificationvalid == '已过期' ? 'highlight' : ''
            "
            >{{ publishUnitJson.pqualificationvalid }}</span
          >
        </div> -->
      </div>
      <div class="right">
        <div class="multiple">
          <p>领导班子成员持证上岗率（%）</p>
          <span :class="publishUnitJson.workerProportion < 50 ? 'highlight' : ''">{{
            publishUnitJson.workerProportion
          }}</span>
        </div>
        <div class="multiple" v-if="querys.pressType == 1">
          <p>取得国家出版专业技术人员资格的编辑人员数</p>
          <!-- highlight -->
          <span :class="querys.pressType == 1 && publishUnitJson.zjCertificate < 10 ? 'highlight' : ''">{{
            publishUnitJson.zjCertificate
          }}</span>
        </div>
        <div class="multiple">
          <p>出版专业中级职称以上人数</p>
          <!-- highlight -->
          <span
            :class="
              (querys.pressType == 1 && publishUnitJson.zjCertificateWorkers < 5) ||
              (querys.pressType == 2 && publishUnitJson.zjCertificateWorkers < 2)
                ? 'highlight'
                : ''
            "
            >{{ publishUnitJson.zjCertificateWorkers }}</span
          >
        </div>
      </div>
    </div>

    <div class="progressTab">
      <div class="headBar">
        <span>流转记录</span>
      </div>
      <el-table :data="tabDat" border style="width: 100%">
        <el-table-column label="序号" width="60" align="center" type="index"> </el-table-column>
        <el-table-column prop="examineName" width="250" label="单位" align="center"></el-table-column>
        <el-table-column prop="name" width="120" label="状态" align="center">
          <template slot-scope="scope">
            <!-- {{scope.row}} -->
            {{ scope.row | tansStr("state") }}
          </template>
        </el-table-column>
        <el-table-column prop="examineMessage" min-width="300" label="审核意见" align="center">
          <template slot-scope="scope">
            <div
              v-for="(item, index) in (scope.row.examineMessage || '').split('；')"
              :key="index"
              style="text-align: left">
              {{ item ? item + (index == (scope.row.examineMessage || "").split("；").length - 1 ? "" : "；") : "" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="pubNumber" width="120" label="批准文号" align="center"></el-table-column>
        <el-table-column prop="checkdAt" width="150" label="操作时间" align="center">
          <template slot-scope="scope">
            <!-- {{scope.row}} -->
            {{ scope.row | tansStr("checkdAt") }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="querys.pressState == 1" class="subArea">
      <div
        class="headBar"
        style="
          height: auto;
          line-height: 20px;
          margin-bottom: 10px;
          padding-bottom: 10px;
          margin-top: 10px;
          padding-top: 10px;
        ">
        <span
          >审核&nbsp;&nbsp;&nbsp;&nbsp;
          <!-- <span style="color: red; font-weight: bold"
            >1.退回：如果出版单位在填写内容中有客观性错误，或者不满足审核通过条件，需要退回出版单位，不满足审核通过条件的出版单位需上传整改报告。</span
          ><br />
          <span style="color: red; font-weight: bold"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.暂缓：出版单位上传整改报告之后，省局可选择暂缓，并给出审核意见。</span
          ><br />
          <span style="color: red; font-weight: bold"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.注销：经和出版单位主办单位沟通之后，主办单位同意注销，省局可选择注销。</span
          > -->
        </span>
      </div>
      <div
        class="headBar"
        style="height: auto; line-height: 20px; margin-bottom: 10px; padding-bottom: 10px; background-color: #fff">
        <span>
          <span style="color: red; font-weight: bold"
            >1.因出版单位在系统填写中存在问题，需退回出版单位修正的，按“退回”键。</span
          ><br />
          <span style="color: red; font-weight: bold"
            >2.审核意见提交（3选1）<br />
            <span style="color: red; font-weight: bold">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;①&nbsp;通过<br /></span>
            <span style="color: red; font-weight: bold"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;②&nbsp;暂缓登记（暂不具备年检通过条件，但仍继续办社的，选此项。缓登后整改应提交整改报告。）<br
            /></span>
            <span style="color: red; font-weight: bold"
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;③&nbsp;注销或拟注销（暂不具备办社基本条件且已经主办单位同意进行注销的，选此项）<br
            /></span>
          </span>
        </span>
      </div>
      <div class="radioBx" style="padding: 10px 30px">
        <el-radio-group v-model="params.status">
          <el-radio :label="'1'">通过</el-radio>
          <!-- <el-radio :label="'3'">退回</el-radio>
          <el-radio :label="'21'">暂缓登记</el-radio> -->

          <el-radio :label="'21'">暂缓登记</el-radio>
          <!-- <el-radio :label="'12'">暂缓</el-radio> -->
          <el-radio :label="'13'">注销或拟注销</el-radio>
          <!-- <el-radio :label="'14'">建议撤销</el-radio> -->
        </el-radio-group>
        <el-input
          v-if="
            params.status == '1' ||
            params.status == '3' ||
            params.status == '21' ||
            params.status == '12' ||
            params.status == '13'
          "
          v-model="params.message"
          type="textarea"
          :rows="5"
          placeholder="请填写意见"></el-input>
        <!-- <el-input
          v-if="params.status == '3'"
          v-model="params.message"
          type="textarea"
          :rows="5"
          placeholder="请填写退回意见"></el-input>
        <el-input
          v-if="params.status == '21'"
          v-model="params.message"
          type="textarea"
          :rows="5"
          placeholder="请填写暂缓登记意见"></el-input>
        <el-input
          v-if="params.status == '12'"
          v-model="params.zanhuanMessage"
          type="textarea"
          :rows="5"
          placeholder="请填写暂缓意见"></el-input>
        <el-input
          v-if="params.status == '13'"
          v-model="params.zhuxiaoMessage"
          type="textarea"
          :rows="5"
          placeholder="请填写建议注销意见"></el-input>
        <el-input
          v-if="params.status == '14'"
          v-model="params.chexiaoMessage"
          type="textarea"
          :rows="5"
          placeholder="请填写建议撤销意见"></el-input> -->
      </div>
    </div>
    <div class="subLine">
      <el-button @click="goBack">返回</el-button>
      <el-button v-if="querys.pressState == 1" @click="goBackExamsave" type="warning">退回</el-button>
      <el-button v-if="querys.pressState == 1" @click="goExamsave" type="danger">提交审核意见</el-button>
    </div>
    <!-- <el-dialog title="流转记录" :visible.sync="dialogTableVisible">
			<el-table :data="gridData">
				<el-table-column property="date" label="时间" width="150"></el-table-column>
				<el-table-column property="name" label="名称" width="200"></el-table-column>
				<el-table-column property="address" label="操作"></el-table-column>
				<el-table-column property="address" label="备注"></el-table-column>
			</el-table>
		</el-dialog> -->
  </div>
</template>

<script>
import CommonTab from "@/views/components/SPEC/SpecCommonTab";
import {
  goProvinceExam,
  successiveHistory,
  successiveHistoryNew,
  publishStatic,
  writeReadTime,
} from "@/api/provinceRole/provinceRole";
import { getPressList, sUpdate0 } from "@/api/pressRole/pressRole";
export default {
  components: {
    CommonTab,
  },
  data() {
    return {
      querys: {
        pressType: "",
        pressId: "",
        pressState: 1,
        pressName: "",
      },
      wSat: 0,
      resDat: [{}],
      params: {
        publishMaterialIds: [],
        status: "1",
        message: "",
        zanhuanMessage: "", // zym.暂缓意见
        chexiaoMessage: "", // zym.撤销意见
        zhuxiaoMessage: "", // zym.注销意见
      },

      //  审核历史
      tabDat: [],
      dialogTableVisible: false,
      repeatJson: {},
      publishUnitJson: {},
    };
  },

  filters: {
    processYijian: function (dat) {
      let yijian = dat.examineMessage;
      if (!yijian) {
        return "";
      }
      console.log("yijian=", yijian);
      let yijianArray = yijian.split("；");
      let backYijian;
      for (let index = 0; index < yijianArray.length; index++) {
        backYijian += yijianArray[index] + "<br/>";
      }
      return backYijian;
    },
    tansStr: function (dat, code) {
      if (code == "state") {
        // console.log('state=',dat.flowName,'  ' ,dat.status)
        if (dat.flowName == "开始") {
          let map = {
            0: "开始",
            7: "提交",
            21: "暂缓登记",
          };
          // console.log("dat.status=", dat.status, "  ", map[dat.status]);
          return map[dat.status];
        } else if (dat.flowName == "省局") {
          let map = {
            1: "通过",
            3: "退回",
            9: "整体上报",

            12: "暂缓",
            13: "注销或拟注销",
            14: "建议撤销",

            21: "暂缓登记",
            // 22: "暂缓登记",
          };
          return map[dat.status];
        } else if (dat.flowName == "国家新闻出版署") {
          let map = {
            1: "通过",
            2: "暂缓",
            3: "退回",
            4: "撤销",
            5: "注销或拟注销",
            10: "整体退回",
            9: "整体发布",

            21: "暂缓登记",
            // 22: "暂缓登记",
          };

          return map[dat.status];
        } else if (dat.flowName == "登记") {
          let map = {
            0: "待登记",
            1: "待登记",
            2: "已登记",
          };

          return map[dat.status];
        } else {
          return dat.flowName;
        }
      } else if (code == "checkdAt") {
        if (dat["checkdAt"] == "Invalid date") {
          return "";
        }
        return dat["checkdAt"].substr(0, 16);
      }
    },
  },

  methods: {
    goBackExamsave: function () {
      const msg = "请填写意见！";
      if ((this.params.message || "").length == 0) {
        this.$message.error(msg);
      } else {
        let msg = "确定已查看完毕，退回出版单位吗？";
        this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.params.publishMaterialIds = [];
            this.params.publishMaterialIds.push(this.$refs.mainTab.postPrevs());

            // 创建新的参数
            let paramsNew = { ...this.params, status: "3" };
            let vm = this;
            const loading = vm.$loading({
              lock: true,
              text: "处理中",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });

            goProvinceExam(paramsNew).then((response) => {
              loading.close();

              let tipCode = response.payload.tipCode;
              let tipMessage = response.payload.tipMessage;
              let resMsg = response.payload.resMsg;
              let appendMsg = resMsg ? resMsg.join(",") : "";
              // console.log('response=',JSON.stringify(response));
              if (tipCode == "fail") {
                this.$message({
                  message: tipMessage + " " + appendMsg,
                  type: "error",
                });
              } else {
                this.$message({
                  message: tipMessage + " " + appendMsg,
                  type: "success",
                });

                // zym.原来的方法
                this.goBack();
              }
            });
          })
          .catch(() => {});
      }
    },
    goExamsave: function () {
      this.params.message = this.params.message || "";
      this.params.message = this.params.message.replace(/\s+/g, "");
      if (this.params.status == 12) {
        this.params.zanhuanMessage = this.params.message.replace(/\s+/g, "");
      }
      if (this.params.status == 13) {
        this.params.zhuxiaoMessage = this.params.message.replace(/\s+/g, "");
      }
      if (this.params.status == 14) {
        this.params.chexiaoMessage = this.params.message.replace(/\s+/g, "");
      }
      // this.params.zanhuanMessage = this.params.zanhuanMessage.replace(/\s+/g, "");
      // this.params.chexiaoMessage = this.params.chexiaoMessage.replace(/\s+/g, "");
      // this.params.zhuxiaoMessage = this.params.zhuxiaoMessage.replace(/\s+/g, "");
      const msg = "请填写意见！";
      if (this.params.status == 3 && this.params.message.length == 0) {
        this.$message.error(msg);
        // this.$message.error("请填写退回意见！");
      } else if (this.params.status == 21 && this.params.message.length == 0) {
        this.$message.error(msg);
        // this.$message.error("请填写暂缓登记意见！");
      } else if (this.params.status == 12 && this.params.zanhuanMessage.length == 0) {
        this.$message.error(msg);
        // this.$message.error("请填写暂缓意见！");
      } else if (this.params.status == 13 && this.params.zhuxiaoMessage.length == 0) {
        this.$message.error(msg);
        // this.$message.error("请填写建议注销意见！");
      } else if (this.params.status == 14 && this.params.chexiaoMessage.length == 0) {
        this.$message.error(msg);
        // this.$message.error("请填写建议撤销意见！");
      } else {
        // let msg = "确定已查看完毕，并对该单位核验材料批以通过处理吗？"; // zym.通过
        // console.log("this.params.status=", this.params.status);
        // if (this.params.status == 3) {
        //   msg = "确定已查看完毕，并对该单位核验材料批以退回处理吗？";
        // } else if (this.params.status == 21) {
        //   msg = "确定已查看完毕，并对该单位核验材料批以退回处理吗？";
        //   // msg = "确定已查看完毕，并对该单位核验材料批以暂缓登记处理吗？";
        // } else if (this.params.status == 12) {
        //   msg = "确定已查看完毕，并对该单位核验材料批以暂缓吗？";
        // } else if (this.params.status == 13) {
        //   msg = "确定已查看完毕，并对该单位核验材料批以注销吗？";
        //   // msg = "确定已查看完毕，并对该单位核验材料批以建议注销吗？";
        // }
        // else if (this.params.status == 14) {
        //   msg = "确定已查看完毕，并对该单位核验材料批以建议撤销吗？";
        // }
        // else if (this.params.status == 1) {
        //   msg = "确定已查看完毕，并对该单位核验材料批以通过处理吗？";
        // } else {
        //   this.$message.error("发现不可操作的审批结果，无法进行操作！");
        //   return;
        // }
        console.log("this.params.status=", this.params.status);
        let msg = "确定已查看完毕，提交审核意见吗？";
        if (this.params.status == 3) {
          msg = "确定已查看完毕，退回出版单位吗？";
        }
        this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.params.publishMaterialIds = [];
            this.params.publishMaterialIds.push(this.$refs.mainTab.postPrevs());
            let vm = this;
            const loading = vm.$loading({
              lock: true,
              text: "处理中",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });
            goProvinceExam(this.params).then((response) => {
              // this.$message.info({
              // 	message: '若音像、电子出版单位全部审核完成，请前往上报板块向进行上报',
              // 	duration: 5000
              // });
              loading.close();

              let tipCode = response.payload.tipCode;
              let tipMessage = response.payload.tipMessage;
              let resMsg = response.payload.resMsg;
              let appendMsg = resMsg ? resMsg.join(",") : "";
              // console.log('response=',JSON.stringify(response));
              if (tipCode == "fail") {
                this.$message({
                  message: tipMessage + " " + appendMsg,
                  type: "error",
                });
              } else {
                this.$message({
                  message: tipMessage + " " + appendMsg,
                  type: "success",
                });

                // zym.原来的方法
                this.goBack();
              }
            });
          })
          .catch(() => {});
      }
    },
    goBack: function () {
      this.$router.go(-1);
    },
    valChangeSearch: function (val) {
      this.gPlist(val);
    },
    // zym.流转记录
    // zym.20250321，处理一下当前选中的审核意见
    historyRecord: function () {
      successiveHistoryNew({ examineId: this.querys.mtId, year1: this.querys.year1 }).then((response) => {
        this.tabDat = response.fFlowTaskList;
        // 查找最后的省局审核意见
        let tabDatProvince = (this.tabDat || []).filter((item) => {
          return item.flowName == "省局";
        });
        if (tabDatProvince && tabDatProvince.length > 0) {
          let last = tabDatProvince[tabDatProvince.length - 1];
          this.params.status = last.status == "0" ? "1" : last.status + "";
          this.params.message = last.examineMessage;
        } else {
          this.params.status = "1";
          this.params.message = "";
        }
        //  successiveHistory({publishId:this.querys.mtId}).then(response => {
        // console.debug('successiveHistory: ', response)
        // for (let i = 0; i < response.fFlowTaskList.length; i++) {
        // 	if (response.fFlowTaskList[i].examineName) {
        // 		this.tabDat.push(response.fFlowTaskList[i]);
        // 	}
        // }
      });
    },

    gPlist: function (year) {
      getPressList({
        type: this.querys.pressType,
        publishId: this.querys.pressId,
        year: year,
      }).then((response) => {
        console.debug("getPressList: ", response);
        let vm = this;
        vm.wSat = 1;
        this.resDat.splice(0, 1, response);
        this.repeatJson = response.verifyWorkerList;
        // console.log(this.repeatJson)
      });
    },

    writeReadTime: function (year) {
      writeReadTime({
        type: this.querys.pressType,
        publishId: this.querys.pressId,
        year: year,
      }).then((response) => {
        console.debug("writeReadTime: ", response);
      });
    },
    //获取出版单位各项统计信息
    getPublishStatic: function () {
      //  publishStatic().then(response => {
      publishStatic({ examineId: this.querys.mtId }).then((response) => {
        console.debug("publishStatic: ", response);
        this.publishUnitJson = response.publisherStatistics;
      });
    },
  },

  created: function () {
    this.querys = {
      pressType: this.$route.query.pressType,
      pressId: this.$route.query.pressId,
      pressName: this.$route.query.pressName,
      pressState: this.$route.query.pressState,

      mtId: this.$route.query.mtId,
      examId: this.$route.query.examId,
      pvcName: this.$route.query.pvcName,
      year1: this.$route.query.year1,
    };

    this.gPlist(this.querys.year1);

    // 更新审阅时间
    if (this.$route.query.updateViewDate && this.$route.query.pressState != 2) {
      this.writeReadTime(this.querys.year1);
    }

    this.historyRecord();
    this.getPublishStatic();
  },
};
</script>

<style lang="scss">
.highlight {
  color: red;
}

.province-C {
  .recordBtn {
    float: right;
    margin-top: 6px;
  }

  padding: 9px;

  .headBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    color: #666666;

    span {
      font-size: 14px;
    }
  }

  .radioBx {
    padding: 30px 90px;
  }

  .el-textarea {
    margin-top: 20px;

    textarea {
      resize: none;
      border-radius: 0px;
    }
  }

  .progressTab {
    margin-top: 9px;
  }

  .progressTab .headBar {
    margin-bottom: 9px;
  }

  .subLine {
    text-align: center;
    margin: 30px 0px;

    .el-button {
      width: 180px;
      margin-top: 12px;
    }
  }

  .informationStatic {
    width: auto;
    overflow: hidden;
    padding: 50px;

    .inforBalance {
      font-size: 14px;
      width: 100%;
      height: auto;
      overflow: hidden;

      p {
        width: 10%;
        float: left;
        text-align: right;
      }

      span {
        float: left;
        line-height: 50px;
      }
    }

    .left,
    .right {
      float: left;
      width: 50%;
      font-size: 14px;

      .multiple {
        width: auto;
        overflow: hidden;

        p {
          float: left;
          width: 50%;
          text-align: right;
        }

        span {
          float: left;
          width: 50%;
          line-height: 50px;
          text-align: center;
        }
      }
    }

    .right {
      float: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// commonTabs.vue?32bc6efb